import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Financials/Revenues/Domain/commands-core';

@Component
export default class RevenuesCommands extends VueCqrs {

	invokeCreateRevenueAccountCommandV1(workspaceId: number, strategyId: string, revenueId: string, name: string, description: string)
	{
		const cmd = new c.CreateRevenueAccountCommandV1(workspaceId, strategyId, revenueId, name, description);
		this.$command(cmd, revenueId);
	}

	invokeDeleteRevenueAccountCommandV1(workspaceId: number, strategyId: string, revenueId: string)
	{
		const cmd = new c.DeleteRevenueAccountCommandV1(workspaceId, strategyId, revenueId);
		this.$command(cmd, revenueId);
	}

	invokeUpdateRevenueAccountCommandV1(workspaceId: number, strategyId: string, revenueId: string, name: string, description: string)
	{
		const cmd = new c.UpdateRevenueAccountCommandV1(workspaceId, strategyId, revenueId, name, description);
		this.$command(cmd, revenueId);
	}
}
